<!-- BaseModal.vue -->

<template>
  <div class="base-modal">
    <div class="fixed inset-0 backdrop-blur-sm bg-black/30 dark:bg-black/60 transition-opacity base-modal"></div>

    <div class="fixed base-modal inset-0 overflow-y-auto" @mousedown.self="$emit('close')">
      <div class="flex items-center justify-center min-h-full p-4 text-center sm:p-0" @mousedown.self="$emit('close')">
        <div ref="panel" @click.stop :class="customClass" role="dialog" aria-modal="true" tabindex="-1"
          :aria-label="label || null"
          class="relative bg-surface baseModalSlot shadow-xl p-2 overflow-x-hidden border border-line text-left overflow-hidden transform transition-all sm:my-8 rounded-2xl outline-none">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Dialog shell: Esc or a click on the backdrop emits `close`, and focus moves
// into the dialog on open and back to the opener on close.
export default {
  props: {
    customClass: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
  },
  mounted() {
    this.opener = document.activeElement;
    document.addEventListener("keydown", this.onKeydown);
    this.$nextTick(() => this.$refs.panel && this.$refs.panel.focus());
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeydown);
    if (this.opener && typeof this.opener.focus === "function") this.opener.focus();
  },
  methods: {
    onKeydown(e) {
      if (e.key === "Escape") this.$emit("close");
    },
  },
};
</script>

<style scoped>
.base-modal {
  z-index: 1000;
}
</style>
